import styled from 'styled-components';

export default styled.div`
  && {
    @media only screen and (max-width: 1024px) and (min-width: 768px) {
      .header1 .ant-steps {
        padding-right: 0 !important;
      }
    }
    width: 100%;
    .inline {
      display: inline-block;
    }
    .header1 {
      height: 172px;
      background-color: rgba(193, 225, 141, 1);
      padding: 25px 40px;
      .icon1 {
        margin-right: 10px;
        margin-bottom: 25px;
        font-size: 20px;
      }
      .anticon-right {
        margin-top: 3px;
        font-size: 15px;
      }
      .wrap-steps {
        background-color: white;
        border-radius: 23.5px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding-left: 26px;
      }
      .step-item {
        display: flex;
        padding: 14px 10px 13px 10px;
        color: #777777;
        font-family: Hiragino Kaku Gothic Pro;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
      }
      .step-icon {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #ffffff;
        background: #c4c4c4;
        border-radius: 50px;
        margin-right: 5px;
      }
      .step-arrow {
        width: 12px;
        height: 12px;
        margin-top: 5px;
        border: 1px solid rgba(0, 0, 0, 0.25);
        border-bottom: none;
        border-left: none;
        transform: rotate(45deg);
        content: '';
      }
      .step-active {
          .step-icon {
            background: #C1E18D;
          }
          color: #000000;
      }
    .header2 {
      height: 68px;
      background-color: rgba(236, 255, 184, 1);
      padding-right: 65px;
      padding-left: 80px;
      display: flex;
      align-items: center;
      .anticon-plus {
        font-size: 25px;
      }
    }
  }
`;
